// 3-state theme: 'system' (follows OS), 'light', 'dark'.
// Persists choice to localStorage; applies .dark class to <html> on change.

const STORAGE_KEY = 'te:theme';

export function getStoredTheme() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch (_) {}
  return 'system';
}

export function applyTheme(choice) {
  const resolved = resolveTheme(choice);
  const root = document.documentElement;
  if (resolved === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
}

export function setTheme(choice) {
  try { localStorage.setItem(STORAGE_KEY, choice); } catch (_) {}
  applyTheme(choice);
}

export function resolveTheme(choice) {
  if (choice === 'light' || choice === 'dark') return choice;
  // 'system' — read OS preference
  try {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
  } catch (_) {}
  return 'light';
}

// Initialize on app boot. Also subscribes to OS theme changes when in 'system' mode.
export function initTheme() {
  applyTheme(getStoredTheme());
  try {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    mq.addEventListener('change', () => {
      if (getStoredTheme() === 'system') applyTheme('system');
    });
  } catch (_) {}
}
